import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getStudentLogonAccess = async (studentId, courseId) => {
  const res = await axios.apiCadernoVirtual(
    "/diary-service/course-data-access",
    { params: { studentId, courseId } }
  );
  return res;
};

export const useStudentLogonAccess = ({ config, studentId, courseId } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["studentLogon", { studentId, courseId }],
    queryFn: () => getStudentLogonAccess(studentId, courseId),
  });
};
